module.exports = __webpack_public_path__ + "img/ozo_logo.ec943b81.svg";